import React, { useEffect, KeyboardEvent } from "react";

interface HamburgerMenuProps {
  hasMiddleBar?: boolean;
}

const HamburgerMenu: React.FC<HamburgerMenuProps> = ({ hasMiddleBar = false }: HamburgerMenuProps): JSX.Element => {
  const body = document.body;
  const mobileClass = "open-mobile-menu";

  useEffect((): void => {
    if (body) {
      body.classList.remove(mobileClass);
    }
  });

  const handleOnClick = (): void => {
    if (body) {
      if (body.classList.contains(mobileClass)) {
        body.classList.remove(mobileClass);
      } else {
        body.classList.add(mobileClass);
      }
    }
  };

  const handleKeyDown = (e: KeyboardEvent): void => {
    if (e.key === "Enter" && !e.ctrlKey && !e.altKey && !e.shiftKey && !e.metaKey) {
      handleOnClick();
      e.preventDefault();
    }
  };

  return (
    <div role="button" aria-label="hamburger menu button" className="hamburger-menu-wrapper" onClick={handleOnClick} onKeyDown={handleKeyDown} tabIndex={0}>
      <div className="hamburger">
        <div className="bar top-bar" />
        {hasMiddleBar && <div className="bar middle-bar" />}
        <div className="bar bottom-bar" />
      </div>
    </div>
  );
};

export default HamburgerMenu;
